export const raiderIoScores: Record<string, string> = {
    all: 'All',
    dps: 'DPS',
    healer: 'Healer',
    tank: 'Tank',
};

export const raiderIoScoreOrder: string[] = ['all', 'dps', 'healer', 'tank'];
